// ─── Messages d'erreur lisibles ───────────────────────────────────
// On garde TOUJOURS le code Firestore : c'est lui qui permet de diagnostiquer
// (règle trop stricte, index manquant, réseau). Une liste vide silencieuse est
// le pire des retours — cf. le bug « mes inventaires n'apparaissent pas ».
export function messageErreur(e) {
  const code = e?.code || '';
  if (code.includes('permission-denied')) {
    return 'Accès refusé par les règles de sécurité (permission-denied). Vérifie que tu es bien membre de l\'espace actif.';
  }
  if (code.includes('unavailable'))         return 'Firestore injoignable (réseau). Réessaie dans un instant.';
  if (code.includes('failed-precondition')) return 'Index Firestore manquant (failed-precondition).';
  if (code.includes('unauthenticated'))     return 'Session expirée — reconnecte-toi.';
  return `${e?.message || String(e)}${code ? ` [${code}]` : ''}`;
}
